<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div>
      <div id="track">
        <div class="d-flex justify-content-between">
          <div>
            <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span><em name="Exhibition"></em><span>/</span
            ><span class="px-0">大會活動</span><span>/</span
            ><span @click.prevent="toEventMain" style="color: #1a73e8" class="pointer px-0">{{ EventName }}</span
            ><span>/</span><a href="javascript:history.back()">選擇推廣產品</a><span>/</span>建立推廣產品介紹
          </div>
          <div>
            <span class="bold">登入帳號 :</span>
            <span> {{ UserId }}</span>
          </div>
        </div>
      </div>
      <!-- track end -->
      <!-- article -->
      <article>
        <div class="contentBox">
          <div class="container">
            <h1>建立推廣產品介紹</h1>
            <p class="my-3">&nbsp;</p>
            <p class="alert">
              <i class="fas fa-exclamation-circle"></i>
              請勿上傳與本展無關或是妨害社會善良風俗之內容，主辦單位有權刪除不適當的內容。
            </p>
            <p class="my-3">&nbsp;</p>

            <form id="form" @submit.prevent="AddPromotionPro">
              <input type="hidden" name="RegNo" />

              <p class="formTitle">產品名稱</p>
              <p>
                {{ ProductDetail.ProName }}
              </p>

              <p class="my-3">&nbsp;</p>

              <p class="formTitle">分類 <span class="red">*</span></p>
              <div class="form-row">
                <div class="form-group col-md-2">
                  <select class="form-control text-dark" v-model="mCatID" required>
                    <option value="">-- 請選擇 --</option>
                    <option v-for="item in EventCatList" :value="item.mCatID">{{ item.mCatName }}</option>
                  </select>
                </div>
              </div>

              <p class="clear"></p>
              <p class="my-3">&nbsp;</p>

              <span v-if="inputDescHidden == 0">
                <p class="formTitle">{{ inputDescName }} <span class="red" v-if="inputDescRequired == 0">*</span></p>
                <div class="langTip">
                  <input
                    type="text"
                    name="Desc"
                    class="maxText textStyle inputDescRe"
                    maxlength="20"
                    v-model="reg_Desc"
                  />
                  <span>中 </span>
                </div>
                <div class="blueBG mt-1">{{ inputDescNotes }}</div>

                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputDescHidden2 == 0">
                <p class="formTitle">{{ inputDescName2 }} <span class="red" v-if="inputDescRequired2 == 0">*</span></p>
                <div class="langTip">
                  <input
                    type="text"
                    name="Desc2"
                    class="maxText textStyle inputDescRe2"
                    maxlength="20"
                    v-model="reg_Desc2"
                  />
                  <span>中 </span>
                </div>
                <div class="blueBG mt-1">{{ inputDescNotes2 }}</div>

                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputOnlineDateHidden == 0">
                <p class="formTitle">上市時間 <span class="red" v-if="inputOnlineDateRequired == 0">*</span></p>
                <div class="langTip">
                  <input
                    type="text"
                    name="LaunchDate"
                    class="maxText textStyle inputOnlineDateRe"
                    maxlength="20"
                    v-model="reg_LaunchDate"
                  />
                  <span>中 </span>
                </div>
                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputPriceHidden == 0">
                <p class="formTitle">市價 NT$ <span class="red" v-if="inputPriceRequired == 0">*</span></p>
                <div class="langTip">
                  <input
                    type="text"
                    name="Price"
                    class="maxText textStyle inputPriceRe"
                    maxlength="20"
                    v-model="reg_Price"
                  />
                  <span>中 </span>
                </div>
                <p class="my-3">&nbsp;</p>
              </span>

              <span v-if="inputDiscountPriceHidden == 0">
                <p class="formTitle">展場限定價 <span class="red" v-if="inputDiscountPriceRequired == 0">*</span></p>
                <div class="langTip">
                  <input
                    type="text"
                    name="Discount"
                    class="maxText textStyle inputDiscountPriceRe"
                    maxlength="20"
                    v-model="reg_DiscountPrice"
                  />
                  <span>中 </span>
                </div>
                <p class="my-3">&nbsp;</p>
              </span>
              <div class="d-flex justify-content-center">
                <input type="submit" value="確定送出" class="btnStyle mr-4" />
                <div class="btnStyle btnGray" @click.prevent="backSelectPro">返回</div>
              </div>
            </form>
          </div>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: '建立推廣產品介紹 - 展昭參展商管理系統',
      }
    },

    data() {
      return {
        UserId: '',
        RegNo: '',
        CSRF_Token: '',
        lang: 'tw',
        EventDetail: {},
        MarketingRegisterList: [],
        ProductID: '',
        ProductDetail: {},
        reg_Desc: '',
        reg_LaunchDate: '',
        reg_Price: '',
        reg_DiscountPrice: '',
        EventDetail: {},
        EventCatList: [],
        mCatID: '',
        eventId: '',
        inputDescHidden: '',
        inputOnlineDateHidden: '',
        inputPriceHidden: '',
        inputDiscountPriceHidden: '',
        inputDescName: '',
        EventName: '',

        inputDescRequired: '',
        inputDescNotes: '',
        inputDescName2: '',
        inputDescHidden2: '',
        inputDescRequired2: '',
        inputDescNotes2: '',
        inputOnlineDateRequired: '',
        inputPriceRequired: '',
        inputDiscountPriceRequired: '',
      }
    },

    watch: {},

    methods: {
      toEventMain() {
        const vm = this
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
      },
      AddPromotionPro() {
        const vm = this
        const url = '/apiExhibitors/MarketingEventRegister/'

        const info = {
          regNo: vm.RegNo,
          eventId: vm.eventId,
          proNo: vm.ProductID,
          mCatID: vm.mCatID,
          reg_Desc: vm.reg_Desc,
          reg_Desc2: vm.reg_Desc2,

          reg_LaunchDate: vm.reg_LaunchDate,
          reg_Price: vm.reg_Price,
          reg_DiscountPrice: vm.reg_DiscountPrice,
          CSRF: vm.CSRF_Token,
        }

        // console.log(info)

        axios.post(url, info).then(function (response) {
          // console.log(response)
          if (response.data.Code == 200) {
            alert('您已成功報名！')
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
          } else if (response.data.Code == 500) {
            alert('系統忙碌，請稍後再試！')
            document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`
          } else if (response.data.Code == 253) {
            alert('報名活動與報名表序號的參展代碼不一致！')
            // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
          } else if (response.data.Code == 254) {
            alert('報名表序號與報名產品為不同參展商！')
            // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
          } else if (response.data.Code == 255) {
            alert('報名時間超過活動的參展商系統上下線時間！')
            // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
          } else if (response.data.Code == 256) {
            alert('廠商報名表的報名攤位數小於活動的限制攤位數！')
            // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
          } else if (response.data.Code == 257) {
            alert('廠商已報名數量大於活動的限制報名數量！')
            // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
          } else if (response.data.Code == 258) {
            alert('選取之產品已報名過活動！')
            // document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
          }
        })
      },

      backSelectPro() {
        const vm = this
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotionSelectPro?no=${vm.RegNo}&eventId=${vm.eventId}`
      },
    },

    computed: {},

    created() {
      const vm = this

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      //url取出展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1].split('&')[0]
      vm.ProductID = currentUrl.split('id=')[1].split('&')[0]
      vm.eventId = currentUrl.split('eventId=')[1]

      let url = `/apiExhibitors/Product/${vm.RegNo}/${vm.ProductID}`
      axios.get(url).then(function (response) {
        // console.log(response.data.Data)
        vm.ProductDetail = response.data.Data
      })

      //取得線上展總資料
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/MarketingEvent?eventId=${vm.eventId}`).then((response) => {
        // console.log(response.data.Data)

        vm.EventDetail = response.data.Data
        vm.EventCatList = response.data.Data.category

        // 欄位顯示判定

        vm.inputDescHidden = response.data.Data.inputDescHidden
        vm.inputDescHidden2 = response.data.Data.inputDescHidden2
        vm.inputOnlineDateHidden = response.data.Data.inputOnlineDateHidden
        vm.inputPriceHidden = response.data.Data.inputPriceHidden
        vm.inputDiscountPriceHidden = response.data.Data.inputDiscountPriceHidden

        vm.inputDescName = response.data.Data.inputDescName
        vm.inputDescName2 = response.data.Data.inputDescName2
        vm.inputDescNotes = response.data.Data.inputDescNotes
        vm.inputDescNotes2 = response.data.Data.inputDescNotes2

        //必填

        vm.inputDescRequired = response.data.Data.inputDescRequired
        vm.inputDescRequired2 = response.data.Data.inputDescRequired2
        vm.inputOnlineDateRequired = response.data.Data.inputOnlineDateRequired
        vm.inputPriceRequired = response.data.Data.inputPriceRequired
        vm.inputDiscountPriceRequired = response.data.Data.inputDiscountPriceRequired

        if (vm.inputDescRequired == 0) {
          $('.inputDescRe')[0].setAttribute('required', 'true')
        }
        if (vm.inputDescRequired2 == 0) {
          $('.inputDescRe2')[0].setAttribute('required', 'true')
        }
        if (vm.inputOnlineDateRequired == 0) {
          $('.inputOnlineDateRe')[0].setAttribute('required', 'true')
        }
        if (vm.inputPriceRequired == 0) {
          $('.inputPriceRe')[0].setAttribute('required', 'true')
        }
        if (vm.inputDiscountPriceRequired == 0) {
          $('.inputDiscountPriceRe')[0].setAttribute('required', 'true')
        }

        vm.EventName = response.data.Data.eventName

        // 開啟時間判定
        let OpenRegiterDate = response.data.Data.backEndStartDate
        let CloseRegiterDate = response.data.Data.backEndEndDate
        let Nowdate = Date.parse(new Date()).valueOf()

        if (Nowdate < OpenRegiterDate) {
          alert('活動尚未開放')
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
        } else if (Nowdate > CloseRegiterDate) {
          alert('活動尚未開放')
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/promotion?eventId=${vm.eventId}&no=${vm.RegNo}`
        }
      })
    },
  }
</script>

<style lang="scss"></style>
